import styled from 'styled-components'

export const Box = styled.span<{ $lines: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${(p) => p.$lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`
